export default {
    BUSINESS_REFERRAL_WIDGET: 'business-referral-widget',
    NEW_SIGNUP_WIDGET_WIX_V2_MODAL: 'new-signup-widget-wix-v2-modal',
    CUSTOMER_IMPORT_WIDGET: 'customer-import-widget',
    PROVISIONAL_CHECKOUT_FLAG_SLUG: 'create-provisional-transaction',
    MOBILE_WIX_RESIZE_WINDOW: 'widget-mobile-wix-resize-window',
    SOCIAL_REWARDS: 'widget-social-rewards',
    NEW_SIGNUP_WIDGET_SHOPIFY_MODAL: 'new-signup-widget-shopify-modal',
    PROVISIONAL_CHECKOUT_WIX: 'widget-provisional-checkout-wix',
    NEW_REFERRAL_CAMPAIGN_ERROR_HANDLER: 'new-referral-campaign-error-handler',
    SIGNUP_CONFIRMATION: 'widget-signup-confirmation',
    FAST_REDEMPTIONS: 'widget-fast-redemptions',
    SEGMENT_CLOSE_WELCOME_COINS: 'widget-segment-close-welcome-coins',
    CACHE_API: 'widget-cache-api',
    NEW_COIN_ICON: 'new-coin-icon',
    SEGMENT_SANITIZER: 'segment-sanitizer',
    EXPIRABLE_COINS: 'widget-expirable-coins',
};
